import { useEffect } from 'react'
import { useStore } from 'react-redux'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import { InitState } from '../../../redux/reducers/root/initialState'
import { validateAndSaveInsertion } from '../../../redux/thunks/insertionData/insertionData'

const isMissingPrice = (price: unknown): boolean => price === undefined || price === null || price === ''

export function useUpdatePriceWhenValuationLoaded() {
  const { recommendedValue, insertionData } = useAppSelector((state: InitState) => ({
    recommendedValue: state.valuationFeature.recommendedValue,
    insertionData: state.insertionFeature.insertionData,
  }))
  const store = useStore<InitState>()
  const dispatch = useAppDispatch()

  useEffect(() => {
    const userDismissedPrefill = insertionData.isRecommendedPricePrefilledVisible === false
    const canApplyRecommendedValue =
      insertionData.isRecommendedPricePrefilledVisible === true || isMissingPrice(insertionData.price)

    if (recommendedValue === undefined || userDismissedPrefill || !canApplyRecommendedValue) {
      return
    }

    const currentInsertionData = store.getState().insertionFeature.insertionData
    const userDismissedPrefillForCurrentInsertion = currentInsertionData.isRecommendedPricePrefilledVisible === false
    const canApplyRecommendedValueForCurrentInsertion =
      currentInsertionData.isRecommendedPricePrefilledVisible === true || isMissingPrice(currentInsertionData.price)

    if (userDismissedPrefillForCurrentInsertion || !canApplyRecommendedValueForCurrentInsertion) {
      return
    }

    const alreadyApplied =
      currentInsertionData.price === recommendedValue &&
      currentInsertionData.recommendedPrefilledPrice === recommendedValue &&
      currentInsertionData.isRecommendedPricePrefilledVisible === true
    if (alreadyApplied) {
      return
    }

    dispatch(
      validateAndSaveInsertion({
        ...currentInsertionData,
        price: recommendedValue,
        recommendedPrefilledPrice: recommendedValue,
        isRecommendedPricePrefilledVisible: true,
      })
    )
  }, [dispatch, insertionData.isRecommendedPricePrefilledVisible, insertionData.price, recommendedValue, store])
}
